<template>
  <el-container class="grid-layout">
    <!-- Page Header -->
    <el-header class="title" height="max-content">
      <h5 class="text-sc">
        <b>
          {{ title }}
        </b>
      </h5>
      <el-button
        type="text"
        class="back-button"
        @click="goto('LineNotifyNotice')"
      >
        กลับ
      </el-button>
    </el-header>

    <!-- Page Body -->
    <el-main class="grid-layout">
      <!-- Steps -->
      <div class="grid-layout content">
        <el-steps
          :active="step"
          class="sc-steps"
          finish-status="success"
          align-center
        >
          <el-step title="ผู้ใช้งาน" />
          <el-step title="โครงการ" />
          <el-step title="บันทึกข้อมูล" />
        </el-steps>
      </div>

      <!-- Administrator Selection -->
      <div v-if="step === 1" class="grid-layout content">
        <!-- LINE UID Input -->
        <el-form class="sc-form" label-position="top" @submit.native.prevent>
          <el-form-item class="input-line" label="LINE UID" required>
            <el-input
              v-model="lineId"
              type="text"
              placeholder="LINE UID จาก Webhook"
            />
          </el-form-item>
        </el-form>

        <!-- User Input -->
        <div class="list-item">
          <div class="grid-layout item el-card" @click="selector('admin')">
            <el-avatar
              :size="80"
              :class="{
                active: !!role,
              }"
              shape="square"
            >
              <span v-if="!!role">
                <b>
                  {{ role }}
                </b>
              </span>
              <i v-else class="el-icon-user-solid" />
            </el-avatar>
            <div>
              <b>
                {{ name || "เลือกผู้ใช้งาน" }}
              </b>
              <p class="text-secondary">
                {{ email || "ผู้ดูแลระบบบ้านรู้ใจ" }}
              </p>
            </div>
            <div v-if="!!email">
              <el-button
                type="danger"
                icon="el-icon-delete"
                circle
                @click.stop="admin.value = {}"
              />
            </div>
          </div>
        </div>

        <!-- Actions -->
        <div class="text-center">
          <el-button
            :disabled="!lineId || !admin.value.id"
            class="sc-color"
            type="primary"
            @click="step = step + 1"
          >
            ต่อไป
          </el-button>
        </div>
      </div>

      <!-- Project Selection -->
      <div v-if="step === 2" class="grid-layout content">
        <!-- Project Input -->
        <div class="text-center">
          <el-button
            :disabled="allNotice"
            type="primary"
            @click="selector('project')"
          >
            เลือกโครงการ
          </el-button>
        </div>

        <!-- Project Empty -->
        <div v-if="!allNotice">
          <el-empty
            v-if="project.value.length < 1"
            :image-size="200"
            description="
              ไม่พบข้อมูล
            "
          />
        </div>

        <!-- Project List -->
        <div class="grid-layout list-item">
          <div v-if="allNotice" class="grid-layout item el-card">
            <el-avatar :size="80" shape="square">
              <b> ALL </b>
            </el-avatar>
            <div class="content">
              <b class="text-title"> ทุกโครงการ </b>
              <p class="text-secondary text-ellipsis">
                รับการแจ้งเตือนทุกโครงการ
              </p>
            </div>
          </div>
          <div
            v-for="(item, i) in projectItems"
            v-else
            :key="i"
            class="grid-layout item el-card"
          >
            <el-avatar :size="80" shape="square">
              <b>
                {{ item.code }}
              </b>
            </el-avatar>
            <div class="content">
              <b class="text-title">
                {{ item.name }}
              </b>
              <p class="text-secondary text-ellipsis">
                {{ item.location }}
              </p>
            </div>
            <div>
              <el-button
                type="danger"
                icon="el-icon-delete"
                circle
                @click="unselect(item.id)"
              />
            </div>
          </div>
          <el-pagination
            v-if="paging.total > paging.size"
            :current-page.sync="paging.current"
            :page-size="paging.size"
            :total="paging.total"
            class="text-center"
            layout="
              prev, pager, next
            "
          />
        </div>

        <!-- Actions -->
        <div class="text-center">
          <el-button type="info" @click="step = step - 1"> กลับ </el-button>
          <el-button
            :disabled="!valid"
            class="sc-color"
            type="primary"
            @click="
              () => {
                step = step + 1
                save()
              }
            "
          >
            บันทึก
          </el-button>
        </div>
      </div>

      <!-- Result -->
      <div v-if="step === 3" class="grid-layout content">
        <!-- Status -->
        <el-result
          :icon="result.icon"
          :sub-title="result.description"
          title="บันทึกข้อมูล"
        >
        </el-result>

        <!-- Actions -->
        <div class="text-center">
          <el-button type="info" @click="reset"> เพิ่มผู้ใช้งาน </el-button>
          <el-button
            class="sc-color"
            type="success"
            @click="goto('LineNotifyNotice')"
          >
            รายการผู้ใช้งาน
          </el-button>
        </div>
      </div>

      <!-- Dialog -->
      <el-dialog
        :title="dialog.title"
        :visible.sync="dialog.open"
        :close-on-click-modal="false"
        :show-close="false"
        top="0"
      >
        <!-- Admin Selector -->
        <SelectAdmin
          v-if="dialog.type === 'admin'"
          :search="admin.search"
          :page="admin.page"
          :selected="admin.value"
          @select="
            (data) => {
              admin.value = data
              dialog.open = false
            }
          "
          @page-change="
            ({ text, page }) => {
              admin.search = text
              admin.page = page
            }
          "
        >
        </SelectAdmin>

        <!-- Project Selector -->
        <SelectProject
          v-if="dialog.type === 'project'"
          :search="project.search"
          :page="project.page"
          :selected="project.value.map(({ id }) => id)"
          @select="(data) => select(data)"
          @unselect="(id) => unselect(id)"
          @page-change="
            ({ text, page }) => {
              project.search = text
              project.page = page
            }
          "
        >
        </SelectProject>

        <!-- Dialog Footer -->
        <div slot="footer" class="text-center">
          <el-button
            v-if="dialog.type == 'project'"
            :disabled="projectLength == 0"
            type="primary"
            @click="dialog.open = false"
          >
            เพิ่ม {{ projectLength > 0 ? projectLength : "" }}
          </el-button>
          <el-button
            v-if="dialog.type == 'project'"
            type="danger"
            @click="
              () => {
                dialog.open = false
                project.value = []
              }
            "
          >
            ยกเลิก
          </el-button>
          <el-button
            v-if="dialog.type == 'admin'"
            type="danger"
            @click="dialog.open = false"
          >
            ปิด
          </el-button>
        </div>
      </el-dialog>
    </el-main>
  </el-container>
</template>

<script>
// LINE Notify Service
import { useCases } from "../LineNotifyService"

// Components
import SelectAdmin from "../components/LineNotifySelectAdmin"
import SelectProject from "../components/LineNotifySelectProject"

export default {
  name: "LineNotifyCreate",
  components: {
    SelectAdmin,
    SelectProject,
  },
  data() {
    return {
      title: "เพิ่มผู้ใช้งาน",
      step: 1,
      lineId: "",
      dialog: {
        open: false,
        title: "Dialog",
        type: "",
      },
      admin: {
        page: 1,
        search: "",
        value: {},
      },
      project: {
        page: 1,
        search: "",
        value: [],
      },
      paging: {
        current: 1,
        size: 5,
        total: 0,
      },
      result: {
        icon: "info",
        description: "",
      },
    }
  },
  computed: {
    name({ admin }) {
      const { first_name: firstName, last_name: lastName } = admin.value

      return firstName && lastName ? `${firstName} ${lastName}` : ""
    },
    email({ admin }) {
      return admin.value.email || ""
    },
    role({ admin }) {
      return admin.value.role || ""
    },
    projectItems() {
      // Paging Props
      const { current, size } = this.paging

      // Page Items Limit
      const start = size * current - size
      const end = start + size

      // Page Items
      return this.project.value.slice(start, end)
    },
    projectLength() {
      return this.project.value.length
    },
    selectedProject() {
      return this.project.value.map((e) => e.id)
    },
    roleName() {
      return `${this.admin.value.role || ""}`.toUpperCase()
    },
    allNotice() {
      return ["ADMIN", "CC", "HC", "CRM"].some((e) => e === this.roleName)
    },
    valid() {
      // Project Values
      const lineId = !!this.lineId
      const admin = this.admin.value

      // Validator
      return [
        lineId,
        !!admin.id,
        !!admin.first_name,
        !!admin.last_name,
        !!admin.role,
      ].every((e) => e)
    },
    payload() {
      // LINE UID
      const { lineId } = this

      // User
      const {
        id: ruejaiId,
        email,
        first_name: firstName,
        last_name: lastName,
        role: roleName,
      } = this.admin.value

      // Project
      const project = this.project.value.map(({ id }) => id)

      // Set Payload
      return {
        firstName,
        lastName,
        email,
        lineId,
        project,
        roleName,
        ruejaiId,
      }
    },
  },
  watch: {
    step(val) {
      let nextStep = val
      nextStep = nextStep > 3 ? 3 : nextStep
      nextStep = nextStep < 1 ? 1 : nextStep
      this.step = nextStep
    },
    "dialog.open": function dialogOpenWatcher(open) {
      if (!open)
        this.dialog = {
          open,
          title: "",
          type: "",
        }
    },
    "project.value": function projectValueWatcher(v) {
      this.paging.total = v.length
    },
  },
  methods: {
    goto(name) {
      this.$router.push({ name })
    },
    selector(type) {
      // Default Title
      let title = ""

      // Dialog Title
      switch (type) {
        case "admin":
          title = "ค้นหาผู้ดูแลระบบ"
          break
        case "project":
          title = "ค้นหาโครงการ"
          break
        default:
          break
      }

      // Dialog Status
      this.dialog = {
        open: true,
        title,
        type,
      }
    },
    select(data) {
      // Validate Exist Project
      const exist = this.project.value.some((e) => e.id === data.id)

      // Add Project
      if (!exist) this.project.value.push(data)
    },
    unselect(id) {
      // Unselect Project
      this.project.value = this.project.value.filter((e) => e.id !== id)
    },
    reset() {
      // Steps Component
      this.step = 1

      // LINE UID
      this.lineId = ""

      // Dialog
      this.dialog = {
        open: false,
        title: "",
        type: "",
      }

      // Admin
      this.admin.search = ""
      this.admin.page = 1
      this.admin.value = {}

      // Project
      this.project.search = ""
      this.project.page = 1
      this.project.value = []

      // Project Paging
      this.paging.current = 1

      // Add Result
      this.result = {
        icon: "info",
        description: "",
      }
    },
    async save() {
      // Save Data
      const { code, message } = await useCases.addUser(this.payload)

      // Result Icon
      this.result.icon = code === 20000 ? "success" : "error"

      // Result Message
      this.result.description = message
    },
  },
}
</script>

<style scoped>
@import url("../LineNotify.css");
</style>
